export default function applyFilters(items, filters) {
  return items.filter((item) => {
    return satisfiesFilters(item, filters);
  });
}

function satisfiesFilters(item, filters) {
  return (
    isBetweenIntervals(item, filters) &&
    satisfiesLiteralFilters(item, filters) &&
    satisfiesSimilarityFilters(item, filters) &&
    satisfiesLocation(item, filters)
  );
}

function isBetweenIntervals(item, filters) {
  const intervalFilters = ["price", "km"];

  return intervalFilters.reduce((isBetween, attribute) => {
    if (!isBetween || !item[attribute] || !filters[attribute]) {
      return isBetween;
    }

    if (
      typeof filters[attribute] === "object" &&
      filters[attribute].min &&
      filters[attribute].min > item[attribute]
    ) {
      return false;
    }

    if (
      typeof filters[attribute] === "object" &&
      filters[attribute].max &&
      filters[attribute].max < item[attribute]
    ) {
      return false;
    }

    return isBetween;
  }, true);
}

function satisfiesLiteralFilters(item, filters) {
  const literalFilters = ["brand", "color", "engine", "body", "year"];

  return literalFilters.reduce((isEqual, attribute) => {
    if (!isEqual || !item[attribute] || !filters[attribute]) {
      return isEqual;
    }

    if (
      typeof filters[attribute] === "number" &&
      filters[attribute] !== item[attribute]
    ) {
      return false;
    }

    if (filters[attribute].toUpperCase() !== item[attribute].toUpperCase()) {
      return false;
    }

    return isEqual;
  }, true);
}

function satisfiesSimilarityFilters(item, filters) {
  const similarityFilters = ["name"];

  return similarityFilters.reduce((isSimilar, attribute) => {
    if (!isSimilar || !filters[attribute] || !item[attribute]) {
      return isSimilar;
    }

    if (
      item[attribute].toUpperCase().indexOf(filters[attribute].toUpperCase()) <
      0
    ) {
      return false;
    }

    return isSimilar;
  }, true);
}

function satisfiesLocation(item, filters) {
  if (!filters.location) {
    return true;
  }

  if (item.location === filters.location) {
    return true;
  }

  if (filters.location === "Mendoza" && item.location === null) {
    return true;
  }

  return false;
}
